import { render, staticRenderFns } from "./PacklistActivity.vue?vue&type=template&id=09c8bd36&scoped=true"
import script from "./PacklistActivity.vue?vue&type=script&lang=js"
export * from "./PacklistActivity.vue?vue&type=script&lang=js"
import style0 from "./PacklistActivity.vue?vue&type=style&index=0&id=09c8bd36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8bd36",
  null
  
)

export default component.exports